"use client";

import { createContext, useContext } from "react";

/**
 * Whether social sign-in (Google) should be offered on the auth pages.
 * Set from the server in the (auth) layout (which reads the OAuth env) and read
 * by the client sign-in/sign-up pages so the button only shows when configured.
 */
const GoogleEnabledContext = createContext(false);

export function AuthConfigProvider({
  googleEnabled,
  children,
}: {
  googleEnabled: boolean;
  children: React.ReactNode;
}) {
  return (
    <GoogleEnabledContext.Provider value={googleEnabled}>
      {children}
    </GoogleEnabledContext.Provider>
  );
}

export const useGoogleEnabled = () => useContext(GoogleEnabledContext);
